// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18621ee2","952":"5c955740"}[chunkId] + ".chunk.js";
};